"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _MuiPickersUtilsProvider = _interopRequireDefault(require("@material-ui/pickers/MuiPickersUtilsProvider"));

var _momentTimezone = _interopRequireDefault(require("moment-timezone"));

var _DatePicker = require("@material-ui/pickers/DatePicker");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReduxI18n = require("react-redux-i18n");

var _jsxRuntime = require("react/jsx-runtime");

function TextDatePicker(props) {
  function handleDateChange(date) {
    props.onChange({
      target: {
        value: date,
        type: 'date'
      }
    });
  }

  if (_momentTimezone.default.locale() === 'en') {
    _momentTimezone.default.locale('en-GB');
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MuiPickersUtilsProvider.default, {
    utils: _moment.default,
    locale: (0, _momentTimezone.default)().locale(),
    libInstance: _momentTimezone.default,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePicker.KeyboardDatePicker, {
      autoOk: true,
      label: props.label,
      value: props.value ? props.value : null,
      onChange: handleDateChange,
      format: _momentTimezone.default.localeData().longDateFormat('L'),
      placeholder: props.placeholder,
      error: props.error,
      helperText: props.helperText,
      disabled: props.disabled,
      minDate: props.minDate,
      maxDate: props.maxDate,
      cancelLabel: _reactReduxI18n.I18n.t('action.cancel'),
      okLabel: _reactReduxI18n.I18n.t('action.confirm')
    })
  });
}

TextDatePicker.defaultProps = {
  label: '',
  placeholder: '',
  minDate: (0, _momentTimezone.default)().year(1900).startOf('y'),
  maxDate: (0, _momentTimezone.default)().add(20, 'y').endOf('y')
};
TextDatePicker.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.instanceOf(_momentTimezone.default),
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  placeholder: _propTypes.default.string,
  error: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  minDate: _propTypes.default.instanceOf(_momentTimezone.default),
  maxDate: _propTypes.default.instanceOf(_momentTimezone.default)
};
var _default = TextDatePicker;
exports.default = _default;
//# sourceMappingURL=TextDatePicker.js.map